<template>
  <section id="main-content">
    <template v-if="userFormSubStep == 'email-prompt'">
      <h1>Qual o seu email?</h1>
      <ul class="tips">
        <li>Se você já é usuário da OMU use o e-mail da sua conta.</li>
      </ul>
      <div id="email-container" class="white-box single-field-container field-and-button">
        <label class="generic-label" for="email">E-mail</label>
        <input
          class="generic-input"
          type="email"
          id="email"
          v-model="email"
          v-on:keyup.enter="searchUser"
        />
        <!--        <span class="validation-message error">Você tem certeza que esse e-mail existe mesmo?</span>-->
        <!--        <span class="validation-message error">O Gmail tem colocado nossos e-mails no Spam. Olha lá!</span>-->
        <button class="btn-action" @click="searchUser" :class="{'btn-loading': amILoading}" :disabled="amILoading">
          Avançar
        </button>
      </div>
    </template>

    <template v-if="userFormSubStep == 'login'">
      <h1>Login</h1>
      <ul class="tips">
        <li>Oi, {{ currentUser.name }}, tudo bem?</li>
      </ul>
      <div id="login-container" class="white-box">
        <div>
          <label class="generic-label" for="email">E-mail</label>
          <input type="email" class="generic-input" v-model="email" disabled/>
          <ul class="tips small-tips">
            <li>
              Entrar usando outro
              <button
                class="linky-button"
                @click="searchOtherUser"
              >endereço de email
              </button>
              .
            </li>
            <li>
              Caso tenha esquecido sua senha,
              <a
                class="linky-button"
                href="https://inscricoes.omu.preface.com.br/sui/sui_users/recuperar"
              >primeiro recupere a sua senha</a>.
            </li>
          </ul>
        </div>
        <div class="single-field-container field-and-button">
          <label class="generic-label" for="password">Senha</label>
          <input
            class="generic-input"
            type="password"
            v-on:keyup.enter="login"
            v-model="password"
            id="password"
          />
          <button class="btn-main-action small" @click="login" :class="{'btn-loading': amILoading}"
                  :disabled="amILoading">Entrar
          </button>
        </div>
      </div>
    </template>

    <template v-if="userFormSubStep == 'register'">
      <h1>Cadastro de um novo usuário</h1>
      <div id="registration-container" class="white-box">
        <div>
          <label class="generic-label" for="email">E-mail</label>
          <input type="email" class="generic-input" v-model="email" disabled/>
          <ul class="tips small-tips">
            <li>
              Se você já tem uma conta pode acessá-la
              <button
                class="linky-button"
                @click="searchOtherUser"
              >usando outro endereço de email
              </button>
              .

            </li>
          </ul>
          <div class="triple-field-container">
            <div class="single-field-container">
              <label class="generic-label" for="name">Nome</label>
              <input class="generic-input" id="name" type="text" v-model="name"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="surname">Sobrenome</label>
              <input class="generic-input" id="surname" type="text" v-model="surname"/>
            </div>
            <div class="single-field-container">
              <label class="generic-label" :for="gender">Gênero</label>
              <select class="generic-select" :id="gender" v-model="gender">
                <option disabled selected>---</option>
                <option :key="gender-0" value="f">feminino</option>
                <option :key="gender-1" value="m">masculino</option>
                <option :key="gender-2" value="?">outro</option>
                <option :key="gender-3" value="nao_respondeu">prefiro não informar</option>
              </select>
            </div>
          </div>

          <div class="single-field-container">
            <label class="generic-label" for="password">Senha</label>
            <input
              type="password"
              placeholder="(No mínimo 6 caracteres.)"
              minlength="6"
              class="generic-input"
              v-on:keyup.enter="saveNewUser"
              v-model="password"
              id="password"
            />
          </div>

          <div class="double-field-container"></div>

          <div class="single-field-container">
            <label class="generic-label" for="password_retype">Digite a senha novamente</label>
            <input
              type="password"
              placeholder="(No mínimo 6 caracteres.)"
              minlength="6"
              class="generic-input"
              v-on:keyup.enter="saveNewUser"
              v-model="password_retype"
              id="password_retype"
            />
          </div>
          <div class="double-field-container"></div>

          <div class="single-field-container" v-if="currentModality === 'teacher' || currentModality === 'wildcard'">
            <label class="generic-label" for="password_retype">Incluir endereço para correspondência? (opcional, mas
              necessário para receber por correio eventuais medalhas).</label>
            <select
              class="generic-input"
              v-on:keyup.enter="saveNewUser"
              v-model="mail_address"
              id="mail_address"
            >
              <option value="y">Sim</option>
              <option value="n">Não</option>
            </select>
          </div>

          <div class="double-field-container" v-if="mail_address === 'y'">
            &nbsp;
            <div class="single-field-container">
              <label class="generic-label" for="about">Aos cuidados de: <small>(opcional, preencher caso deseje usar o
                endereço da escola)</small></label>
              <input class="generic-input" id="about" type="text" v-model="about"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="address">Logradouro (rua, avenida, etc)</label>
              <input class="generic-input" id="address" type="text" v-model="address"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="number">Número</label>
              <input class="generic-input" id="number" type="text" v-model="number"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="address_2">Complemento <small>(opcional)</small></label>
              <input class="generic-input" id="address_2" type="text" v-model="address_2"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="city">Cidade</label>
              <input class="generic-input" id="city" type="text" v-model="city"/>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="state">Estado</label>
              <select class="generic-input" id="state" v-model="state">
                <option v-for="state in stateList" v-bind:value="state.id" v-bind:key="state.id">
                  {{ state.name }}
                </option>
              </select>
            </div>

            <div class="single-field-container">
              <label class="generic-label" for="cep">CEP <small>(somente números)</small></label>
              <input class="generic-input" id="cep" type="number" v-model="cep" min="10000000" max="99999999"/>
            </div>
          </div>
          <div class="double-field-container">&nbsp;</div>

          <button class="btn-main-action" @click="saveNewUser" :class="{'btn-loading': amILoading}"
                  :disabled="amILoading">Cadastrar seu usuário
          </button>
        </div>
      </div>
    </template>

    <template v-if="userFormSubStep == 'validation'">
      <h1>Código de validação?</h1>
      <ul class="tips">
        <li>Enviamos um código de 6 números para validar a sua conta.</li>
        <li>Preencha o código abaixo.</li>
      </ul>
      <div id="validation-container" class="white-box single-field-container field-and-button">
        <label class="generic-label" for="email">Código</label>
        <input
          class="generic-input"
          type="codigo"
          id="codigo"
          v-model="validation_code"
          v-on:keyup.enter="validateNewUser"
        />
        <button class="btn-action" @click="validateNewUser">Avançar</button>
      </div>
    </template>
  </section>
</template>

<script>
import store from "../../store";
import router from "../../router";
import {mapGetters, mapActions} from "vuex";
import Vue from "vue";
import {mockData, pickOne} from "../../assets/mock-data";
import stateList from "../../assets/state-list";

export default {
  name: "StepUserId",
  data: function () {
    return {
      "stateList": stateList
    }
  },
  computed: {
    ...mapGetters(["userFormSubStep", "currentUser", "amILoading", "currentModality"]),
    email: {
      get: function () {
        return store.state.User.UserForm.email;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "email"});
      }
    },
    name: {
      get: function () {
        return store.state.User.UserForm.name;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "name"});
      }
    },
    surname: {
      get: function () {
        return store.state.User.UserForm.surname;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "surname"});
      }
    },
    gender: {
      get: function () {
        return store.state.User.UserForm.gender;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "gender"});
      }
    },
    password: {
      get: function () {
        return store.state.User.UserForm.password;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "password"});
      }
    },
    password_retype: {
      get: function () {
        return store.state.User.UserForm.password_retype;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "password_retype"});
      }
    },
    validation_code: {
      get: function () {
        return store.state.User.UserForm.validation_code;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "validation_code"});
      }
    },
    mail_address: {
      get: function () {
        return store.state.User.UserForm.mail_address;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "mail_address"});
      }
    },
    address: {
      get: function () {
        return store.state.User.UserForm.address;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "address"});
      }
    },
    address_2: {
      get: function () {
        return store.state.User.UserForm.address_2;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "address_2"});
      }
    },
    about: {
      get: function () {
        return store.state.User.UserForm.about;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "about"});
      }
    },
    city: {
      get: function () {
        return store.state.User.UserForm.city;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "city"});
      }
    },
    state: {
      get: function () {
        return store.state.User.UserForm.state;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "state"});
      }
    },
    number: {
      get: function () {
        return store.state.User.UserForm.number;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "number"});
      }
    },
    cep: {
      get: function () {
        return store.state.User.UserForm.cep;
      },
      set: function (value) {
        store.commit("USER_FORM_CHANGE", {value, field: "cep"});
      }
    }
  },
  methods: {
    ...mapActions(["searchUser", "searchOtherUser"]),
    login: function () {
      store.commit("START_LOADING");

      let promise;

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function () {
            resolve({data: {saved: true, data: pickOne(mockData.SuiUsers)}})
          }, 600)
        })
      } else {
        let data = {
          username: store.state.User.UserForm.email,
          password: store.state.User.UserForm.password
        };

        promise = Vue.axios.post('sui_login.json?action=login', data);
      }

      return promise
        .then(
          function (response) {
            if (response.data.saved) {

              response.data.data.NewSuiUser = response.data.data.SuiUser;
              store.commit('LOGIN_USER', response.data.data);
              router.push({
                name: "nothingButFlowers",
                params: {
                  subsSlug: store.state.Subscription.subscription_slug,
                  step: "report"
                }
              });
              store.commit('GOTO_STEP_REGISTRATION_REPORT');

              return;
            }

            if (response.data.validation) {
              alert_validation_mesages(response.data.validation, "Não foi possível fazer o login.");
            }
          },
          function () {
            alert('Erro ao fazer login');
          }
        )
        .finally(function () {
          store.commit("END_LOADING");
        })
    },
    saveNewUser: function () {
      store.commit("START_LOADING");
      store.commit("REGISTER_USER_SUBMIT");

      let promise;

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function () {
            resolve({data: {saved: true, data: pickOne(mockData.SuiUsers)}})
          }, 600)
        })
      } else {
        const submittedData = store.state.User.UserForm.SubmittedData;
        let data = {
          NewSuiUser: {
            name: submittedData.name,
            surname: submittedData.surname,
            gender: submittedData.gender,
            password: submittedData.password,
            password_retype: submittedData.password_retype,
            email: submittedData.email,
            has_address: submittedData.has_address,
            address: submittedData.address,
            address_2: submittedData.address_2,
            about: submittedData.about,
            city: submittedData.city,
            state: submittedData.state,
            cep: submittedData.cep,
            number: submittedData.number
          }
        };
        promise = Vue.axios.post('new_sui_user.json', data);
      }

      return promise
        .then(
          function (response) {
            if (response.data.saved) {
              store.commit('START_USER_VALIDATION');
              return;
            }

            if (response.data.validation) {
              alert_validation_mesages(response.data.validation, "Não foi possível fazer o cadastro.");
            }
          },
          function () {
            alert("Erro ao salvar o seu cadastro");
          }
        )
        .finally(function () {
          store.commit("END_REGISTER_USER_SUBMIT");
          store.commit("END_LOADING");
        });
    },
    validateNewUser: function () {
      store.commit("START_LOADING");
      store.commit("VALIDATE_USER_SUBMIT");

      let promise;

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function () {
            resolve({data: {saved: true, data: pickOne(mockData.SuiUsers)}})
          }, 600)
        })
      } else {
        let data = {
          NewSuiUser: {
            email: store.state.User.UserForm.SubmittedData.email,
            validation_code: store.state.User.UserForm.SubmittedData.validation_code
          }
        };
        promise = Vue.axios.post('new_sui_user.json?action=validate', data);
      }

      return promise
        .then(
          function (response) {
            if (response.data.saved) {
              alert("Conta validada com sucesso!\nAgora, por favor, faça o login.");
              store.commit("START_LOGIN");
              return;
            }

            if (response.data.validation) {
              alert_validation_mesages(response.data.validation, "Erro ao validar o cadastro.");
            }
          },
          function () {
            alert("Ocorreu um erro ao validar o cadastro.");
          }
        )
        .finally(function () {
          store.commit("END_LOADING");
        })
    },
    dispatchUser: function () {
      if (store.state.amILoading) {
        return;
      }

      store.dispatch("goToRegistrationReport").then(function () {
        router.push({
          name: "nothingButFlowers",
          params: {
            subsSlug: store.state.Subscription.subscription_slug,
            step: "report"
          }
        });
      });
    }
  }
};

function alert_validation_mesages(validation, first_line) {
  if (typeof validation !== "object") {
    return;
  }

  let message = first_line + "\n";
  for (let val in validation) {
    if (validation[val].length) {
      message += ["", ...validation[val]].join("\n • ");
    }
  }
  alert(message);
}
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

#email-container {
  margin: pad(0) 0;
}

input {
  &:invalid {
    background: #FFDDDD;
  }
}

.white-box {
  margin-top: pad(0);
  padding-top: pad(0);
}
</style>
